import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { LoadingService } from '../../../../shared/services/loading.service';
import { UserService } from '../../../../shared/services/user.service';
import { ManageEquipmentService } from '../../manage-equipment.service';
import { SetupEquipmentService } from '../../../setup-equipment/setup-equipment.service';
import { NotificationsService } from '../../../../../../node_modules/angular2-notifications';
import { Equipment, EquipmentInspectionForcastingViewModel } from '../../../setup-equipment/setup-equipment.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from "moment";
import { InterpretationService } from '../../../../../app/modules/interpretation/interpretation.service';
import { TRACKForcastVM } from '../../../../../app/modules/interpretation/models/interpretation.model';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
@Component({
  selector: 'app-inspection-planner',
  templateUrl: './inspection-planner.component.html',
  styleUrls: ['./inspection-planner.component.scss']
})
export class InspectionPlannerComponent implements OnInit {
  equipmentId: number = 0;
  isInspector: boolean;
  saving: boolean = false;
  _isLoading: boolean = false;
  inspectionId: number;
  equipment: Equipment = new Equipment();
  labelPosition = 'after';
  dayDiff: number;
  dayDiff1: number;
  dayDiff2: number;
  NextPMSMU: number;
  NextPmDistance: number;
  SecondPMSMU: number;
  SecondDistance: number;
  FloatingSMU: number;
  FloatingDistance: number;
  dayDiff3: number;
  FloatingSMU2: number;
  FloatingDistance2: number;
  userUOD: string = 'km'; 
  unitList = [
    { Id: 0, Name: 'Hours' },
    { Id: 4, Name: 'KMS' },
    { Id: 1, Name: 'Days' },
    { Id: 2, Name: 'Weeks' },
    { Id: 3, Name: 'Months' },

  ]
  unitPeriodicList = [
    { Id: 4, Name: 'Weekly' },
    { Id: 5, Name: 'Monthly' },
    { Id: 6, Name: 'Quarterly' },
    { Id: 7, Name: 'Yearly' }
  ]
  constructor(private _loading: LoadingService,
    private _user: UserService,
    public dialogRef: MatDialogRef<InspectionPlannerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _manageService: ManageEquipmentService,
    private _setupService: SetupEquipmentService,
    private _notification: NotificationsService,
    private _interp: InterpretationService,private readonly _pref: PreferencesService
  ) { }
  forecastMethod: number = 1;
  ngOnInit() {
    this.isInspector = this.data.isInspector;
    this.equipmentId = this.data.equipmentId;
    this.inspectionId = this.data.inspectionId;
    this.getUserUOD(); 
    if (this.inspectionId > 0) {
      this.getDailyUsagehoursAndDailyDistance(this.inspectionId)
    }

    if (this.equipmentId) {
      this.loadequipmentDetail();
    }
  }

  loadequipmentDetail(){
    this._isLoading = true;
    this._setupService.getEquipmentSetupDetails(this.equipmentId).subscribe(result => {
      //console.log('getEquipmentSetupDetails result', result);
      this.equipment = result;
       this.equipment.AvgDistance = this.userUOD === 'km' ? this.equipment.AvgDistance : Math.round(this.equipment.AvgDistance * 0.621371);
      if (this.equipment != null) {
        if (this.equipment.NextPmDate != null) {
          this.onNextPmDateChange(1, this.equipment.NextPmDate )
        }  if (this.equipment.SecondPmDate  != null) {
          this.onNextPmDateChange(2, this.equipment.SecondPmDate)
        }  if (this.equipment.FloatingDate1 != null) {
          this.onNextPmDateChange(3, this.equipment.FloatingDate1)
        }  if (this.equipment.FloatingDate2 != null) {
          this.onNextPmDateChange(4, this.equipment.FloatingDate2)
        }
      }
    }, error => console.error(error), () => { this._isLoading = false; });
  }

  updateInspectionPlanner() {
    //debugger;
    this.saving = true;
    let model = new EquipmentInspectionForcastingViewModel();
    model.Id = this.equipmentId;
    model.JobsiteId = this.equipment.JobsiteId;
    model.CreatedByUserId = this.equipment.CreatedByUserId;
    model.EnableAutoInspectionPlanner = this.equipment.EnableAutoInspectionPlanner;
    model.UsedMonday = this.equipment.UsedMonday;
    model.UsedTuesday = this.equipment.UsedTuesday;
    model.UsedWednesday = this.equipment.UsedWednesday;
    model.UsedThursday = this.equipment.UsedThursday;
    model.UsedFriday = this.equipment.UsedFriday;
    model.UsedSaturday = this.equipment.UsedSaturday;
    model.UsedSunday = this.equipment.UsedSunday;
    model.InspectEvery = this.equipment.InspectEvery;
    model.InspectEveryUnitTypeId = this.equipment.InspectEveryUnitTypeId;
    model.HoursOfUsePerDay = this.equipment.HoursOfUsePerDay;
    model.ForecastMethod = this.equipment.ForecastMethod;
    model.AvgDistance = this.convertDistanceMiToKm(this.equipment.AvgDistance);
    model.CalculateMethod = this.equipment.Calculatemethod;
    model.ManualDate = this.equipment.ManualDate;
    model.ManualDateStr = this.equipment.ManualDate != null ? moment(this.equipment.ManualDate).format('MM/DD/YYYY') : null;
    model.ManualHours = this.equipment.ManualHours;
    model.CalculateDisplayStatus = this.equipment.CalculateDisplayStatus;
    model.SafetyCheck = this.equipment.SafetyCheck;
    model.SafetyCheckValue = this.equipment.SafetyCheckValue;
    model.ShowLastInspWorn = this.equipment.ShowLastInspWorn;
    model.ShowWornToday = this.equipment.ShowWornToday;
    model.DistanceRatio = this.equipment.DistanceRatio;
    this._setupService.updateInspectionForecast(model).subscribe(result => {
      if (result.m_Item1 > 0) {
        this._notification.success('Success', result.m_Item2);
        this.dialogRef.close(true);
      }
      else this._notification.warn('Failed', result.m_Item2);
    }, error => console.error(error), () => { this.saving = false; });
  }
  Istrue: boolean = false;
  ShowDiv() {
    this.Istrue = !this.Istrue;
  }

  systemCalculateValue: number = 0;
  CheckBoxValue(value: number) {
    this.equipment.Calculatemethod = value;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }


  onNextPmDateChange(value: number, date: any) {
     if (this.forecastDataVM == null) {
       return;
     }
    if (value == 1) {
      if (this.equipment.NextPmDate != null) {
        const start = new Date(this.forecastDataVM.LastInpectionDateOnly).getTime();
        const end = new Date(this.equipment.NextPmDate).getTime();
        const diff = end - start;
        this.dayDiff = Math.floor(diff / (1000 * 60 * 60 * 24));
        this.dayDiff = this.dayDiff - (Math.floor(this.dayDiff / 7) * (7 - this.forecastDataVM.ActiveDays));

        if (this.calculatedUsaghourChecked) {
          this.NextPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
          this.NextPmDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff) + (+this.forecastDataVM.LastInspectionDistance);
        }
        else {
          this.NextPMSMU = (this.forecastDataVM.DailyUsageHours * this.dayDiff) + (+this.forecastDataVM.LastinspectionSMU);
          this.NextPmDistance = (this.forecastDataVM.DailyUageDistance * this.dayDiff) + (+this.forecastDataVM.LastInspectionDistance);
        }

      }

    } else if (value == 2) {
      //this.conditionalCalculatedValue = false;
      //this._minDateFlaotingDate1=this.ForecastData.controls['PM_2_Date'].value;
      if (this.equipment.NextPmDate != null && this.equipment.SecondPmDate != null) {

        let startdate = this.equipment.NextPmDate;
        let endDate = this.equipment.SecondPmDate;
        const start = new Date(startdate).getTime();
        const end = new Date(endDate).getTime();
        const diff = end - start;
        if (endDate != null) {
          this.dayDiff1 = Math.floor(diff / (1000 * 60 * 60 * 24));
        }
        if (this.calculatedUsaghourChecked) {
          this.SecondPMSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff1) + (+this.NextPMSMU);
          this.SecondDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff1) + (+this.NextPmDistance);
        }
        else {
          this.SecondPMSMU = (this.forecastDataVM.DailyUsageHours * this.dayDiff1) + (+this.NextPMSMU);
          this.SecondDistance = (this.forecastDataVM.DailyUageDistance * this.dayDiff1) + (+this.NextPmDistance);
        }
      }

    } else if (value == 3) {
      //this._minDateFlaotingDate2=this.ForecastData.controls['Floating_Date'].value;
      if (this.equipment.SecondPmDate != null && this.equipment.FloatingDate1 != null) {
        const start = new Date(this.equipment.SecondPmDate).getTime();
        const end = new Date(this.equipment.FloatingDate1).getTime();
        const diff = end - start;
        if (this.equipment.FloatingDate1 != null) {
          this.dayDiff2 = Math.floor(diff / (1000 * 60 * 60 * 24));
        }
        if (this.calculatedUsaghourChecked) {
          this.FloatingSMU = (this.forecastDataVM.ForecastEntryHours * this.dayDiff2) + (+this.SecondPMSMU);
          this.FloatingDistance = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff2) + (+this.SecondDistance);
        }
        else {
          this.FloatingSMU = (this.forecastDataVM.DailyUsageHours * this.dayDiff2) + (+this.SecondPMSMU);
          this.FloatingDistance = (this.forecastDataVM.DailyUageDistance * this.dayDiff2) + (+this.SecondDistance);
        }

      }

    } else {

      if (this.equipment.FloatingDate1 != null && this.equipment.FloatingDate2 != null) {
        const start = new Date(this.equipment.FloatingDate1).getTime();
        const end = new Date(this.equipment.FloatingDate2).getTime();
        const diff = end - start;
        if (this.equipment.FloatingDate2 != null) {
          this.dayDiff3 = Math.floor(diff / (1000 * 60 * 60 * 24));
        }
        if (this.calculatedUsaghourChecked) {
          this.FloatingSMU2 = (this.forecastDataVM.ForecastEntryHours * this.dayDiff3) + (+this.FloatingSMU);
          this.FloatingDistance2 = (this.forecastDataVM.ForecastEntryDistance * this.dayDiff3) + (+this.FloatingDistance);
          //this.diffBetweenLastandPreviousInpectionUsgHours4 = (this.FloatingSMU2 - this.FloatingSMU);
          //this.diffBetweenLastandPreviousInpectionDistance4 = (this.FloatingDistance2 - this.FloatingDistance);
        }
        else {
          this.FloatingSMU2 = (this.forecastDataVM.DailyUsageHours * this.dayDiff3) + (+this.SecondPMSMU);
          this.FloatingDistance2 = (this.forecastDataVM.DailyUageDistance * this.dayDiff3) + (+this.FloatingDistance);
          //this.diffBetweenLastandPreviousInpectionUsgHours4 = (this.FloatingSMU2 - this.FloatingSMU);
          // this.diffBetweenLastandPreviousInpectionDistance4 = (this.FloatingDistance2 - this.FloatingDistance)
        }

      }

    }

  }

  forecastDataVM: TRACKForcastVM;
  hourChecked: boolean;
  calculatedUsaghourChecked: boolean;

  getDailyUsagehoursAndDailyDistance(inspectionId) {
    this._interp.getDailyUsageHoursAndDistance(inspectionId).subscribe(result => {
      this.forecastDataVM = result;
      if (this.forecastDataVM.ForecastMethod != "" && this.forecastDataVM.ForecastMethod != null) {
        if (this.forecastDataVM.ForecastMethod == "Hours") {
          this.hourChecked = true;
        } else {
          this.hourChecked = false;
        }
      }
      else {
        this.hourChecked = true;
      }
      if (this.forecastDataVM.DailyUsageCalculationMethod != "" && this.forecastDataVM.DailyUsageCalculationMethod != null) {
        if (this.forecastDataVM.DailyUsageCalculationMethod == "calculated") {
          this.calculatedUsaghourChecked = true;
        } else {
          this.calculatedUsaghourChecked = false;
        }
      } else {
        this.calculatedUsaghourChecked = true;
      }

      
    });
  }

  @ViewChild('myForecast') myButton!: ElementRef;

  onSubmit() {
    var foreCastData = new TRACKForcastVM();
    


    foreCastData.InspectionId = this.inspectionId;
    foreCastData.DailyUsageHours = this.forecastDataVM.DailyUsageHours;
    foreCastData.DailyUageDistance = this.forecastDataVM.DailyUageDistance;
    foreCastData.ForecastMethod = this.hourChecked ? "Hours" : "Distance";
    foreCastData.PmNextDateService = this.equipment.NextPmDate != null ? new Date(this.equipment.NextPmDate) : null;
    foreCastData.PmNextDateServiceString = this.equipment.NextPmDate != null ? moment(this.equipment.NextPmDate).format('MM/DD/YYYY') : null;
    foreCastData.SecondPmNextDateService = this.equipment.SecondPmDate != null ? new Date(this.equipment.SecondPmDate) : null;
    foreCastData.SecondPmNextDateServiceString = this.equipment.SecondPmDate != null ? moment(this.equipment.SecondPmDate).format('MM/DD/YYYY') : null;
    foreCastData.FloatingDate = this.equipment.FloatingDate1 != null ? new Date(this.equipment.FloatingDate1) : null;
    foreCastData.FloatingDateString = this.equipment.FloatingDate1 != null ? moment(this.equipment.FloatingDate1).format('MM/DD/YYYY') : null;
    foreCastData.FloatingDate2 = this.equipment.FloatingDate2 != null ? new Date(this.equipment.FloatingDate1) : null;
    foreCastData.FloatingDateString2 = this.equipment.FloatingDate2 != null ? moment(this.equipment.FloatingDate2).format('MM/DD/YYYY') : null;
    foreCastData.PmNextDateServiceSMU = +this.NextPMSMU;
    foreCastData.PmNextDateServiceDOE = +this.NextPmDistance;
    foreCastData.SecondPmNextDateServiceSMU = +this.SecondPMSMU;
    foreCastData.SecondPmNextDateServiceDOE = +this.SecondDistance;
    foreCastData.FloatingSMU = +this.FloatingSMU;
    foreCastData.FloatingDOE = +this.FloatingDistance;
    foreCastData.FloatingSMU2 = +this.FloatingSMU2;
    foreCastData.FloatingDOE2 = +this.FloatingDistance2;
    foreCastData.DailyUsageCalculationMethod = this.calculatedUsaghourChecked == true ? "calculated" : "manually";
    this._interp.SaveForeCastData(foreCastData).subscribe(
      res => {
        if (res == 1) {
          //this.LoadUcPlannerDetail();
          this._notification.success('Success', 'Data saved successfully');
        }
      },
      error => {
        this._notification.error('Error saving data', 'Failed to save the record');
      }
    );
  }

//TT-9235
    getUserUOD(){
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOD = res.UnitofDistance;
    })
  }
   //to save values in KM when user preferance is in miles
    convertDistanceMiToKm(val: number): number {
     return this.userUOD === 'km' ? val : Math.round(val * 1.60934);
  }

  limitOneDecimal(event: any) {
  let value = event.target.value;

  const regex = /^\d+(\.\d{0,1})?/;

  const match = value.match(regex);
  if (match) {
    event.target.value = match[0];
    this.equipment.DistanceRatio = match[0];
  } else {
    event.target.value = '';
    this.equipment.DistanceRatio = 0;
  }
}
}
